import * as React from "react";
import { useHistory } from "react-router";
import { toast } from "sonner";

import { LoginStepServices, PlayerSignUpStep, PlayersServices } from "@/services";
import { redirectPlayerIfSignUpFinished, URLS, useSocialCoachSession } from "@/utils";
import { Button, Card } from "@/components/ui";
import { Png } from "@/assets";
import { SocialNetworkProfiles } from "@/components/SocialNetworkProfiles";

const IntegratedFirstSocialNetworksPage: React.FC = () => {
  const history = useHistory();
  const { playerId, coachId, session } = useSocialCoachSession();
  const [connected, setConnected] = React.useState(false);

  const [isSubmitting, setIsSubmitting] = React.useState(false);

  React.useEffect(() => {
    redirectPlayerIfSignUpFinished(session?.signUpStep);
  }, [session?.signUpStep]);

  const handleSubmit = async () => {
    if (!playerId) return;

    setIsSubmitting(true);
    try {
      await LoginStepServices.sendPlayerStep(PlayerSignUpStep.PLAYER_BUSINESS_DATA);

      if (!connected && coachId) {
        await PlayersServices.sendFollowUpEmail(coachId);
      }

      history.push(URLS.player.firstCongrats);
    } catch (e) {
      toast.error("Failed to save social networks preference");
      console.error(e);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-[calc(100vh-120px)] sm:min-h-[calc(100vh-200px)] p-4 sm:p-6">
      <Card className="w-full max-w-[1000px] p-6 sm:p-10 shadow-lg border-slate-200">
        <div className="flex flex-col mb-6">
          <div className="flex justify-center mb-6">
            <img src={Png.Logo} alt="SocialCoach" className="w-48 sm:w-60" />
          </div>
          <h2 className="text-xl sm:text-2xl font-bold text-slate-900 text-center sm:text-left">
            Connect your accounts
          </h2>
          <p className="text-slate-500 text-center sm:text-left text-sm sm:text-base mt-1">
            Link your social profiles to start sharing content with your audience.
          </p>
        </div>

        <SocialNetworkProfiles onConnected={() => setConnected(true)} />

        <div className="flex flex-col gap-2 mt-8">
          <Button className="w-full h-11 sm:h-12 text-base" onClick={handleSubmit} loading={isSubmitting}>
            Finish Setup
          </Button>
          <Button
            type="button"
            variant="ghost"
            className="w-full h-11 sm:h-12 text-slate-500 hover:text-slate-700 shadow-none font-semibold"
            disabled={isSubmitting}
            onClick={() => {
              if (playerId) {
                sessionStorage.setItem(`skippedOnboarding_${playerId}`, "true");
              }
              history.push(URLS.player.dashboard);
            }}
          >
            Skip for now
          </Button>
        </div>
      </Card>
    </div>
  );
};

export const FirstSocialNetworksPage = IntegratedFirstSocialNetworksPage;
